(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gigi-storie-ugc-marqee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gigi-customer-stories')) {
  customElements.define('gigi-customer-stories', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gigi-stories__track');
      if (!this.track) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const nav = this.querySelector('.gigi-stories__nav');
        nav.hidden = max < 2;
        nav.style.display = max < 2 ? 'none' : 'flex';
        this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft <= 2;
        this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft >= max - 2;
      };
      this.layout = () => {
        if (this.dataset.fullWidth === 'true') {
          this.style.width = '100%'; this.style.marginLeft = '0';
          const left = this.getBoundingClientRect().left;
          this.style.width = document.documentElement.clientWidth + 'px';
          this.style.marginLeft = -left + 'px';
        }
        this.update();
      };
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => {
          const card = this.track.querySelector('.gigi-stories__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, options);
      });
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      window.addEventListener('resize', this.layout, options);
      this.querySelectorAll('video').forEach(video => {
        video.addEventListener('play', () => {
          this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
        }, options);
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
        }, { root: this.track, threshold: .15 });
        this.querySelectorAll('video').forEach(video => this.observer.observe(video));
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.gigi-stories__card');
        if (card && this.contains(card)) this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'auto' });
      }, options);
      this.frame = requestAnimationFrame(this.layout);
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame);
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-marquee2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gigi-premium-marquee')) {
  customElements.define('gigi-premium-marquee', class extends HTMLElement {
    connectedCallback() {
      this.group = this.querySelector('[data-original]');
      this.track = this.querySelector('.gm-track');
      this.viewport = this.querySelector('.gm-viewport');
      if (!this.group || !this.group.children.length) return;
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this.abort.signal };
      this.originals = [...this.group.children];
      this.clone = node => {
        const copy = node.cloneNode(true);
        copy.dataset.clone = ''; copy.setAttribute('aria-hidden', 'true');
        [copy, ...copy.querySelectorAll('*')].forEach(el => {
          el.removeAttribute('id'); el.removeAttribute('data-shopify-editor-block');
          if (el.matches('a, button, [tabindex]')) el.setAttribute('tabindex', '-1');
          if (el.matches('img')) el.alt = '';
        });
        return copy;
      };
      this.layout = () => {
        this.removeAttribute('data-ready');
        this.style.width = '100%'; this.style.marginLeft = '0';
        if (this.dataset.fullWidth === 'true') {
          const left = this.getBoundingClientRect().left;
          this.style.width = document.documentElement.clientWidth + 'px';
          this.style.marginLeft = -left + 'px';
        }
        this.group.querySelectorAll(':scope > [data-clone]').forEach(el => el.remove());
        this.track.querySelectorAll(':scope > [data-clone]').forEach(el => el.remove());
        if (this.motion.matches) return;
        const baseWidth = this.group.getBoundingClientRect().width;
        if (!baseWidth) return;
        const repeats = Math.max(1, Math.ceil(this.viewport.clientWidth / baseWidth));
        for (let i = 1; i < repeats; i++) this.originals.forEach(el => this.group.append(this.clone(el)));
        // La durata scala con le ripetizioni: stessa velocità percepita anche con poche foto.
        this.style.setProperty('--gm-duration', (Number(this.dataset.speed) || 40) * repeats + 's');
        this.track.append(this.clone(this.group));
        this.viewport.scrollLeft = 0;
        this.setAttribute('data-ready', '');
      };
      const queueLayout = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.layout); };
      window.addEventListener('resize', queueLayout, options);
      this.motion.addEventListener('change', queueLayout, options);
      this.querySelector('.gm-pause').addEventListener('click', event => {
        const paused = this.toggleAttribute('data-paused');
        event.currentTarget.setAttribute('aria-pressed', String(paused));
        this.querySelector('[data-pause-label]').textContent = paused ? 'Riprendi scorrimento' : 'Metti in pausa';
      }, options);
      this.viewport.addEventListener('focusin', event => {
        if (this.motion.matches || !event.target.matches('a')) return;
        // Porta il link selezionato da tastiera in vista, mantenendo la pausa.
        const index = this.originals.findIndex(el => el.contains(event.target));
        if (index >= 0) {
          this.track.style.animation = 'none';
          this.track.style.transform = 'translateX(-' + this.originals[index].offsetLeft + 'px)';
        }
      }, options);
      this.viewport.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (!this.viewport.contains(document.activeElement)) {
            this.track.style.animation = ''; this.track.style.transform = '';
          }
        });
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.toggleAttribute('data-offscreen', !this.inView || document.hidden);
        });
        this.observer.observe(this);
      }
      document.addEventListener('visibilitychange', () => this.toggleAttribute('data-offscreen', document.hidden || this.inView === false), options);
      if (this.dataset.editor === 'true') {
        document.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.gm-item');
          if (!item || !this.contains(item)) return;
          this.track.style.animation = 'none';
          this.track.style.transform = 'translateX(-' + item.offsetLeft + 'px)';
        }, options);
        document.addEventListener('shopify:block:deselect', () => {
          this.track.style.animation = ''; this.track.style.transform = '';
        }, options);
      }
      queueLayout();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame);
      this.removeAttribute('data-ready');
      this.group?.querySelectorAll(':scope > [data-clone]').forEach(el => el.remove());
      this.track?.querySelectorAll(':scope > [data-clone]').forEach(el => el.remove());
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
